function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import PropTypes from "prop-types";
// Material imports
import makeStyles from "@mui/styles/makeStyles";
import EmailOutline from "@mui/icons-material/MailOutline";
//Limitless imports
import { useTranslation } from "@limitless/common/hooks";
import SystemDialogue from "../system-dialogue/SystemDialogue";
const useStyles = makeStyles(({
  palette,
  typography
}) => {
  var _palette$dialogues$em, _palette$dialogues, _palette$dialogues$em2, _palette$dialogues$em3, _palette$dialogues2, _palette$dialogues2$e, _palette$dialogues$sy, _palette$dialogues3, _palette$dialogues3$s, _palette$dialogues$sy2, _palette$dialogues4, _palette$dialogues4$s;
  const background = (_palette$dialogues$em = (_palette$dialogues = palette.dialogues) === null || _palette$dialogues === void 0 ? void 0 : (_palette$dialogues$em2 = _palette$dialogues.emailInfo) === null || _palette$dialogues$em2 === void 0 ? void 0 : _palette$dialogues$em2.background) !== null && _palette$dialogues$em !== void 0 ? _palette$dialogues$em : palette.contrast.main;
  const text = (_palette$dialogues$em3 = (_palette$dialogues2 = palette.dialogues) === null || _palette$dialogues2 === void 0 ? void 0 : (_palette$dialogues2$e = _palette$dialogues2.emailInfo) === null || _palette$dialogues2$e === void 0 ? void 0 : _palette$dialogues2$e.text) !== null && _palette$dialogues$em3 !== void 0 ? _palette$dialogues$em3 : palette.contrast.light;
  const borderRadius = (_palette$dialogues$sy = (_palette$dialogues3 = palette.dialogues) === null || _palette$dialogues3 === void 0 ? void 0 : (_palette$dialogues3$s = _palette$dialogues3.system) === null || _palette$dialogues3$s === void 0 ? void 0 : _palette$dialogues3$s.borderRadius) !== null && _palette$dialogues$sy !== void 0 ? _palette$dialogues$sy : 4;
  const systemTextFont = (_palette$dialogues$sy2 = (_palette$dialogues4 = palette.dialogues) === null || _palette$dialogues4 === void 0 ? void 0 : (_palette$dialogues4$s = _palette$dialogues4.system) === null || _palette$dialogues4$s === void 0 ? void 0 : _palette$dialogues4$s.fontFamily) !== null && _palette$dialogues$sy2 !== void 0 ? _palette$dialogues$sy2 : typography.fontFamily;
  return {
    primaryBackground: {
      backgroundColor: background,
      borderRadius
    },
    primaryText: {
      color: text,
      marginRight: 5,
      fontFamily: systemTextFont
    }
  };
});
const STANDARD_REPLY = "We usually reply within a few minutes, but for more complex issues please check your email for your answer";
const SystemEmailInfoDialogue = ({
  message,
  ...rest
}) => {
  const classes = useStyles();
  const {
    t
  } = useTranslation();
  const {
    newMsgCustomerContactDate,
    maskedEmail
  } = message;
  let bodyToTranslate = STANDARD_REPLY;
  if (!newMsgCustomerContactDate) {
    //we've failed to send an email
    bodyToTranslate = "We've had trouble sending you an email, please stay on this page for an expert response";
  }
  if (maskedEmail && newMsgCustomerContactDate) {
    //We have sent {0} an email with a link back to this page
    bodyToTranslate = rest.body;
  }
  return /*#__PURE__*/React.createElement(SystemDialogue, _extends({
    dialogueClasses: classes,
    Icon: /*#__PURE__*/React.createElement(EmailOutline, {
      className: classes.primaryText
    }),
    showRightIcon: false
  }, rest, {
    body: t(bodyToTranslate, maskedEmail)
  }));
};
export default SystemEmailInfoDialogue;
SystemEmailInfoDialogue.propTypes = {
  message: PropTypes.object.isRequired
};